import React, { useState, useEffect } from 'react';
import { GatsbySeo } from 'gatsby-plugin-next-seo';
import { window } from 'browser-monads';
import LazyLoader from '../../components/LazyLoader';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActionArea from '@mui/material/CardActionArea';
import CardActions from '@mui/material/CardActions';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';

import {
  FacebookShareCount,
  PinterestShareCount,
  VKShareCount,
  OKShareCount,
  RedditShareCount,
  TumblrShareCount,
  FacebookShareButton,
  FacebookMessengerShareButton,
  FacebookMessengerIcon,
  LinkedinShareButton,
  TwitterShareButton,
  PinterestShareButton,
  VKShareButton,
  OKShareButton,
  TelegramShareButton,
  WhatsappShareButton,
  RedditShareButton,
  EmailShareButton,
  TumblrShareButton,
  LivejournalShareButton,
  MailruShareButton,
  ViberShareButton,
  WorkplaceShareButton,
  LineShareButton,
  WeiboShareButton,
  PocketShareButton,
  InstapaperShareButton,
  FacebookIcon,
  TwitterIcon,
  LinkedinIcon,
  PinterestIcon,
  VKIcon,
  OKIcon,
  TelegramIcon,
  WhatsappIcon,
  RedditIcon,
  TumblrIcon,
  MailruIcon,
  EmailIcon,
  LivejournalIcon,
  ViberIcon,
  WorkplaceIcon,
  LineIcon,
  PocketIcon,
  InstapaperIcon,
  WeiboIcon,
} from 'react-share';
import PageLayout from '../../containers/PageLayout';
import { SlickProductCardList } from '../../components/ProductCardList';

interface Props {
  data: {
    handle: string;
    title: string;
    image: string;
    id: number;
    relatedProduct: any;
  };
}

const SimplePage: React.FC<Props> = ({ data }) => {
  const { handle, title, image, id, relatedProduct } = data;
  const [cardHeight, setCardHeight] = useState(window.innerWidth > 500 ? 500 : window.innerWidth);

  useEffect(() => {
    window.addEventListener('resize', (e) => {
      if (window.innerWidth > 500) {
        setCardHeight(500);
      } else {
        setCardHeight(innerWidth);
      }
    });
  }, [window.innerWidth]);

  const getRandomArrayElements = (arr, count) => {
    let shuffled = arr.slice(0),
      i = arr.length,
      min = i - count,
      temp = 0,
      index = 0;
    while (i-- > min) {
      index = Math.floor((i + 1) * Math.random());
      temp = shuffled[index];
      shuffled[index] = shuffled[i];
      shuffled[i] = temp;
    }
    return shuffled.slice(min);
  };

  const keywords = [
    'Pagani Design Brand Watch',
    'Luxury Watch',
    'Fashion Style Watch',
    'Mechanical Watch',
    'Chronograph Watch',
    'Stainless Steel Band Watch',
    'Quartz Watch',
    'Self-wind Automatic Mechanical Watch',
    'Worldwide Shipping',
    'Sapphire Crystal',
    'Masculino',
    'Shock Resistant',
    'Submariner',
    'tourbillon',
    'Waterproof Wristwatch',
    'Japan Movement',
    'Luminous',
    'Hardlex Dial',
    'Genuine Leather Band Watch',
    'Luxury',
    'Business Watch',
    'Sports Watch',
    'Wrist Watch',
    '30 Days Returns',
  ];
  const titleArr = title.split(' ');
  const newTitle = 'Pagani Design ' + titleArr[2] + ' ' + getRandomArrayElements(keywords, 5).join(' ');
  const hashTag = ', #PaganiDesign, #PaganiDesignWatch, #PaganiWatch, #PagrneDesignWatch, #PagrneWatch, #MechanicalWatch';

  const [relatedProducts] = useState(getRandomArrayElements(relatedProduct, 4));
  const relatedHandles = [];
  relatedProducts.map(({ node }) => {
    return relatedHandles.push(node.handle);
  });

  const siteUrl = 'https://www.paganidesignwatch.com';
  const handleArr = handle.split('-');
  const newHandle = handleArr[0] + '-' + handleArr[1] + '-' + handleArr[2] + '-' + handleArr[3];
  const productName = handleArr[0] + ' ' + handleArr[1] + ' ' + handleArr[2] + ' ' + handleArr[3];

  return (
    <PageLayout>
      <GatsbySeo
        title={newTitle}
        description={newTitle}
        titleTemplate="%s | Pagani Design Watch Official Store"
        openGraph={{
          type: 'website',
          title: `${newTitle}`,
          description: `${newTitle}`,
          url: `${siteUrl}/show/${id}/${newHandle}`,
          images: [
            {
              url: `${image}`,
              width: 800,
              height: 800,
              alt: `${productName}`,
            },
          ],
        }}
      />
      <Container maxWidth="lg">
        <Card sx={{ maxWidth: 500, margin: '2rem auto' }}>
          <CardActionArea href={`https://www.paganidesignwatch.net/${newHandle}`}>
            <CardMedia component="img" width={cardHeight} height={cardHeight} image={image} alt={productName} />
            <CardContent>
              <Typography gutterBottom variant="h6" component="h1">
                {newTitle}
              </Typography>
            </CardContent>
          </CardActionArea>
          <CardActions>
            <Box sx={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', alignItems: 'flex-start' }}>
              <FacebookShareButton
                url={`${siteUrl}/show/${id}/${newHandle}`}
                quote={newTitle}
                hashtag="#paganidesignwatch, #paganiwatch, #onemorewatches">
                <FacebookIcon size={28} round />
              </FacebookShareButton>
              <TwitterShareButton
                url={`${siteUrl}/show/${id}/${newHandle}`}
                title={newTitle}
                hashtags={['paganidesignwatch', 'paganiwatch', 'onemorewatches']}
                related={['onemorewatches']}>
                <TwitterIcon size={28} round />
              </TwitterShareButton>
              <PinterestShareButton url={`${siteUrl}/show/${id}/${newHandle}`} media={image} description={newTitle + hashTag}>
                <PinterestIcon size={28} round />
              </PinterestShareButton>
              <TumblrShareButton
                url={`${siteUrl}/show/${id}/${newHandle}`}
                title={newTitle}
                tags={['paganidesignwatch', 'paganiwatch', 'onemorewatches']}>
                <TumblrIcon size={28} round />
              </TumblrShareButton>
              <TelegramShareButton url={`${siteUrl}/show/${id}/${newHandle}`} title={newTitle}>
                <TelegramIcon size={28} round />
              </TelegramShareButton>
              <WhatsappShareButton url={`${siteUrl}/show/${id}/${newHandle}`} title={newTitle} separator=":: ">
                <WhatsappIcon size={28} round />
              </WhatsappShareButton>
              <LinkedinShareButton url={`${siteUrl}/show/${id}/${newHandle}`}>
                <LinkedinIcon size={28} round />
              </LinkedinShareButton>
              <RedditShareButton url={`${siteUrl}/show/${id}/${newHandle}`} title={newTitle} windowWidth={660} windowHeight={660}>
                <RedditIcon size={28} round />
              </RedditShareButton>
              <VKShareButton url={`${siteUrl}/show/${id}/${newHandle}`} image={image}>
                <VKIcon size={28} round />
              </VKShareButton>
              <OKShareButton url={`${siteUrl}/show/${id}/${newHandle}`} image={image}>
                <OKIcon size={28} round />
              </OKShareButton>
              <LineShareButton url={`${siteUrl}/show/${id}/${newHandle}`} title={newTitle}>
                <LineIcon size={28} round />
              </LineShareButton>
              <LivejournalShareButton url={`${siteUrl}/show/${id}/${newHandle}`} title={newTitle} description={newTitle}>
                <LivejournalIcon size={28} round />
              </LivejournalShareButton>
              <ViberShareButton url={`${siteUrl}/show/${id}/${newHandle}`} title={newTitle}>
                <ViberIcon size={28} round />
              </ViberShareButton>
              <WeiboShareButton url={`${siteUrl}/show/${id}/${newHandle}`} title={newTitle} image={image}>
                <WeiboIcon size={28} round />
              </WeiboShareButton>
              <PocketShareButton url={`${siteUrl}/show/${id}/${newHandle}`} title={newTitle}>
                <PocketIcon size={28} round />
              </PocketShareButton>
              <InstapaperShareButton url={`${siteUrl}/show/${id}/${newHandle}`} title={newTitle}>
                <InstapaperIcon size={28} round />
              </InstapaperShareButton>
            </Box>
          </CardActions>
        </Card>

        <LazyLoader priority={LazyLoader.Priority.LOW}>
          <Grid container spacing={0} sx={{ pb: { xs: '1rem', sm: '2rem', md: '3rem', lg: '4rem' }, px: { xs: '0rem', md: '1rem' } }}>
            <Grid item xs={12}>
              <Typography variant="body2" component="h3" gutterBottom sx={{ my: '1rem', textAlign: 'center' }}>
                Customers who bought this item also bought
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <SlickProductCardList className="slick" products={relatedProducts} handles={relatedHandles} />
            </Grid>
          </Grid>
        </LazyLoader>
      </Container>
    </PageLayout>
  );
};

export default SimplePage;
